export default "__VITE_ASSET__a9999e79__"